import React from "react"
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const LocalTimeDisplay = ({ color = "error", time }) => {
  const [hours, minutes, seconds] = time.split(":").map(Number);

  return (
    <Typography variant="body1" color={color}>
      {hours > 0 && (
        <FormattedMessage
          id={hours === 1 ? "app.time.hours.one" : "app.time.hours"}
          values={{ hours }}
        />
      )}

      {hours > 0 && minutes > 0 && (
        <FormattedMessage id="app.time.and" />
      )}

      {minutes > 0 && (
        <FormattedMessage
          id={minutes === 1 ? "app.time.minutes.one" : "app.time.minutes"}
          values={{ minutes }}
        />
      )}

      {hours === 0 && minutes === 0 && seconds > 0 && (
        <FormattedMessage
          id={seconds === 1 ? "app.time.seconds.one" : "app.time.seconds"}
          values={{ seconds }}
        />
      )}
      
    </Typography>
  );
};

export default LocalTimeDisplay;